import styled from 'styled-components';

export default styled.h2`
  color: #37a9ce;
  font-weight: bold !important;
  font-size: 20px !important;
  margin-bottom: 20px;
  margin-top: 30px;
`;
